/**
 * Shared constants for issue cards and issue detail page.
 * Kept in a plain .ts file (no JSX/components) to avoid fast-refresh conflicts.
 */
import type { EmergenceLevel } from 'features/trend-detection/utils/helpers'

type ActiveEmergenceLevel = Exclude<EmergenceLevel, 'nothing'>

export const EMERGENCE_COLORS: Record<ActiveEmergenceLevel, string> = {
  slightly_elevated: '#4f72a4',
  elevated: '#d98200',
  sharply_elevated: '#ef4444',
}

export const EMERGENCE_NOTHING_COLOR = '#7e8695'

export const EMERGENCE_BOX_BG: Record<EmergenceLevel, string> = {
  nothing: '#f2f3f4',
  slightly_elevated: '#edf1f6',
  elevated: '#fff3e1',
  sharply_elevated: 'rgba(239, 68, 68, 0.12)',
}

export const EMERGENCE_ICON_COLOR: Record<EmergenceLevel, string> = {
  nothing: '#7e8695',
  slightly_elevated: '#4f72a4',
  elevated: '#d98200',
  sharply_elevated: '#ef4444',
}

export const EMERGENCE_BOX_BORDER: Record<EmergenceLevel, string> = {
  nothing: 'rgba(126, 134, 149, 0.25)',
  slightly_elevated: 'rgba(79, 114, 164, 0.25)',
  elevated: 'rgba(217, 130, 0, 0.25)',
  sharply_elevated: 'rgba(239, 68, 68, 0.25)',
}

export const CHART_COLOR = '#45689b'
export const BASELINE_COLOR = '#c0392b'
export const INACTIVE_COLOR = '#d9d9d9'

// Safety/harm indicator: shown on issues whose `is_severe` flag bypassed the
// volume gate or sensitivity threshold. Lightened sharply-elevated red so the
// signal reads as caution adjacent to the louder emergence-tier red without
// competing with it.
export const SAFETY_INDICATOR_COLOR = '#f7a1a1'
export const SAFETY_INDICATOR_TOOLTIP =
  'Flagged as a potential safety or harm issue — surfaced regardless of volume or sensitivity threshold.'
